<template>
  <div>
    <a-form class="custom-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="巡检时间">
            <a-range-picker v-decorator="['created_at']" />
          </a-form-item>
        </a-col>
        <a-col :span="8" :xxl="6">
          <a-form-item label="厅房名称">
            <a-select
                v-decorator="['hall_id']"
                placeholder="请选择厅房"
                allow-clear
            >
              <a-select-option
                  v-for="hall in hallOptions"
                  :key="hall.value"
                  :value="hall.value"
              >
                {{ hall.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8" :xxl="6">
          <a-form-item label="巡检人">
            <a-select
                v-decorator="['user_id']"
                placeholder="请选择巡检人"
                allow-clear
            >
              <a-select-option
                  v-for="user in userOptions"
                  :key="user.id"
                  :value="user.id"
              >
                {{ user.emp_name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>
<script>
import {findHallAllTreeOptions} from "@/api/hall";
import {findTenantUserWithAdminOptions} from "@/api/user";
import {formatRangeBeginDate, formatRangeEndDate} from "@/utils/time";
export default {
  name: 'SearchHallInspection',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'hall_inspection_search' }),
      hallOptions: [],
      hallId: '',
      userOptions:[]
    }
  },
  created() {
    this.fetchUserOptions()
    this.fetchHallOptions()
  },
  methods: {
    handleSearch(e) {
      e.preventDefault()
      const fieldsValue = this.form.getFieldsValue()
      const values = {
        ...fieldsValue,
        created_at_begin: formatRangeBeginDate(fieldsValue.created_at),
        created_at_end: formatRangeEndDate(fieldsValue.created_at)
      }
      this.$emit('submit', values)
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    },
    fetchHallOptions(){
      this.loadingHallOptions = true
      findHallAllTreeOptions().then((res) => {
        if (res.code === 0) {
          this.hallOptions = res.data
        }
        this.loadingHallOptions = false
      })
    },
    fetchUserOptions(){
      findTenantUserWithAdminOptions().then((res) => {
        if (res.code === 0) {
          this.userOptions = res.data
        }
        this.loadingHallOptions = false
      })
    }
  }
}
</script>
